import UserSessionResponse from "./UserSessionResponse"

export interface PublicLinkResponse {
  _id: string
  assetInfo: {
    id: string
    type: string
    path?: string
    name?: string
  }
  clientNumber: string
  createdAt: string
  password: string
  publicURL: string
  updatedAt: string
  validFrom: string
  validTill: string
  exposeDraftAssets: boolean
}

export enum SortEnum {
  DESC_CREATED = 'DESC_CREATED',
  ASC_CREATED = 'ASC_CREATED',
  DESC_VALID_TILL = 'DESC_VALID_TILL',
  ASC_VALID_TILL = 'ASC_VALID_TILL',
  DESC_VALID_FROM = 'DESC_VALID_FROM',
  ASC_VALID_FROM = 'ASC_VALID_FROM',
}

export interface PublicLinksInfo {
  isPublicLink?: boolean
  urlPrefix?: string
  dashboardServerURL?: string
  assetType?: "file" | "folder" | "media-collection"
  assetId?: string
  assetBase64Path?: string
  isAuthenticated?: boolean
  exposeDraftAssets?: boolean
  clientInfo?: {
    clientNumber: string
    imagekitId: string
    settings: {
      onlySignedGet: UserSessionResponse["onlySignedGet"]
      onlyNamedGet: UserSessionResponse["onlyNamedGet"]
      onlySignedVideoGet: UserSessionResponse["onlySignedVideoGet"]
      onlyNamedVideoGet: UserSessionResponse["onlyNamedVideoGet"]
    }
    firstCustomCname: UserSessionResponse["firstCustomCname"]
  }
}

export type PublicLinksResponse = PublicLinkResponse[]
export type PublicLinksForAClientResponse = {
  totalPublicLinks: number
  publicLinks: PublicLinkResponse[]
}
